import React from 'react'
const CBHeader = ({
  step = -1,
  icon,
  label,
  menu,
  buttonLabel,
  buttonAction,
  buttonIcon,
  secondButtonLabel,
  secondButtonAction,
  secondButtonIcon,
  subheader = false,
}) => {
  // Defensive check to ensure buttonIcon is a valid React element
  const safeButtonIcon = React.isValidElement(buttonIcon) ? buttonIcon : null;
  const safeSecondButtonIcon = React.isValidElement(secondButtonIcon) ? secondButtonIcon : null;
  
  // Defensive check to ensure icon is a valid React element
  const safeIcon = React.isValidElement(icon) ? icon : null;
  return (
    <div className="flex flex-row space-x-2 lg:space-x-4 pt-4 pb-4 items-center sm:pl-2 sm:pr-2">
      {(safeIcon || step >= 0) && <div>
        {step >= 0 ? (
          <div
            className={`rounded-full bg-burnt shadow-circle border-burnt text-white border-2  h-6 w-6 flex items-center justify-center`}
          >
            {step}
          </div>
        ) : (
          safeIcon
        )}
      </div>}
      <div>
        <div
          className={`${
            subheader ? 'font-sarabun' : 'font-manrope'
          } text-lg text-neutral_4`}
        >
          {label}
        </div>
      </div>
      <div className="flex-grow "></div>
      <div className="flex w-max space-x-4 items-center justify-self-end ">
        {buttonLabel && (
          <button
            onClick={(e) => buttonAction(e)}
            className="font-manrope bg-white text-neutral_4 pt-1 pb-1 pl-4 pr-3 hover:bg-neutral_2 hover:border-neutral_2 rounded-sm border-2 border-neutral flex space-x-3"
          >
            <div>{buttonLabel}</div>
            {safeButtonIcon && <div>{safeButtonIcon}</div>}
          </button>
        ) }
        {secondButtonLabel && (
          <button
            onClick={(e) => secondButtonAction(e)}
            className="font-manrope bg-white text-neutral_4 pt-1 pb-1 pl-4 pr-3 hover:bg-neutral_2 hover:border-neutral_2 rounded-sm border-2 border-neutral flex space-x-3"
          >
            <div>{secondButtonLabel}</div>
            {safeSecondButtonIcon && <div>{safeSecondButtonIcon}</div>}
          </button>
        ) }
       
      {menu && menu}
      </div>
    </div>
  )
}

export { CBHeader }
